var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg55(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 484,
    viewBox: "0 0 502 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_836_4652)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 251,
    cy: 238,
    rx: 201,
    ry: 192,
    fill: "#D7EFF4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.494 143.987C405.78 144.346 409.571 140.889 409.967 136.273C410.362 131.656 407.2 127.609 402.914 127.249C402.692 127.23 402.476 127.229 402.254 127.23C402.053 124.873 401.68 122.533 401.137 120.23C401.341 120.147 401.544 120.061 401.744 119.958C405.651 117.958 407.355 112.945 405.551 108.761C403.746 104.577 399.123 102.807 395.21 104.807C395.005 104.911 394.811 105.029 394.625 105.15C393.355 103.238 391.939 101.426 390.389 99.7316C390.535 99.5467 390.671 99.3604 390.801 99.1596C393.284 95.3362 392.443 90.1098 388.927 87.4857C385.411 84.8615 380.549 85.8367 378.067 89.6688C377.94 89.8638 377.828 90.0661 377.718 90.2684C375.721 89.3086 373.646 88.5179 371.515 87.9048C371.553 87.6719 371.588 87.4376 371.609 87.1989C371.999 82.5751 372.845 77.3559 368.554 77.0634C358.628 76.3851 356.479 81.2725 356.089 85.8963C356.069 86.1365 356.063 86.3723 356.062 86.608C353.858 86.8585 351.68 87.2923 349.549 87.9048C349.476 87.6865 349.403 87.4682 349.306 87.2542C347.501 83.0714 347.827 80.2799 343.727 81.8473C334.784 85.2661 333.355 90.315 335.158 94.4979C335.253 94.7162 335.359 94.9243 335.467 95.1295C333.66 96.5398 331.964 98.0867 330.394 99.7563C330.225 99.6108 330.054 99.4652 329.87 99.3197C326.353 96.6999 321.492 97.6707 319.01 101.503C316.528 105.335 317.368 110.553 320.884 113.177C321.064 113.311 321.249 113.429 321.436 113.545C320.514 115.725 319.753 117.969 319.161 120.26C318.944 120.222 318.722 120.189 318.506 120.17C314.22 119.811 310.429 123.267 310.033 127.884C309.638 132.5 312.8 136.548 317.086 136.907C317.308 136.925 317.524 136.928 317.746 136.926C317.947 139.284 318.32 141.624 318.863 143.927C318.659 144.01 318.456 144.096 318.256 144.198C314.349 146.199 312.645 151.211 314.449 155.396C316.254 159.58 320.877 161.35 324.79 159.35C324.995 159.245 325.189 159.127 325.375 159.007C326.644 160.914 328.059 162.72 329.607 164.411C329.461 164.595 329.325 164.782 329.195 164.983C326.711 168.806 327.553 174.032 331.069 176.656C334.585 179.281 342.196 178.078 344.678 174.255C344.805 174.059 342.168 174.083 342.278 173.881C344.275 174.841 346.35 175.631 348.48 176.243C348.442 176.477 348.407 176.712 348.387 176.95C347.997 181.574 351.153 185.613 355.439 185.974C359.725 186.335 363.516 182.878 363.912 178.26C363.932 178.02 363.938 177.784 363.94 177.547C366.143 177.298 368.322 176.865 370.452 176.252C370.525 176.47 370.598 176.689 370.696 176.902C372.5 181.085 377.123 182.857 381.037 180.855C384.95 178.854 386.648 173.842 384.844 169.659C384.749 169.44 384.642 169.232 384.534 169.027C386.342 167.618 388.039 166.071 389.607 164.4C389.777 164.546 389.948 164.691 390.132 164.837C393.648 167.457 398.509 166.486 400.991 162.654C403.473 158.822 402.633 153.604 399.117 150.98C398.938 150.846 398.752 150.728 398.565 150.612C399.488 148.432 400.249 146.187 400.841 143.896C401.056 143.934 401.272 143.968 401.494 143.987ZM357.43 162.47C341.87 161.161 330.406 146.497 331.826 129.712C333.246 112.926 347.009 100.375 362.57 101.68C378.13 102.986 389.594 117.654 388.174 134.439C386.754 151.224 372.992 163.77 357.43 162.469V162.47Z",
    fill: "#BFC6D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M401.778 120.231C405.668 118.234 407.363 113.229 405.567 109.05C403.772 104.872 399.17 103.104 395.275 105.101C395.072 105.206 394.878 105.324 394.694 105.444C393.431 103.537 392.023 101.73 390.482 100.039C390.627 99.8546 390.762 99.6686 390.892 99.468C393.363 95.65 395.253 88.075 391.508 85.8281C384.384 81.5639 380.688 86.1638 378.218 89.9833C378.092 90.1781 377.98 90.3801 377.871 90.5821C375.883 89.6236 373.818 88.8341 371.697 88.2218C371.735 87.9893 371.77 87.7553 371.791 87.5169C371.898 86.3436 371.766 85.1606 371.401 84.0401C371.037 82.9196 370.447 81.8852 369.669 81C368.719 88.2204 367.83 95.447 367 102.68C380.29 106.023 389.558 119.487 388.278 134.692C387.192 147.576 378.845 157.946 368.009 161.476C368.034 162.885 368.07 164.296 368.057 165.707C368.021 169.534 367.773 173.369 367.52 177.2C368.572 176.988 369.611 176.734 370.638 176.439C370.71 176.657 370.783 176.875 370.88 177.088C372.676 181.265 376.687 183.806 383.842 180.45C387.801 178.593 386.75 174.032 384.961 169.855C384.867 169.637 384.761 169.429 384.653 169.224C386.453 167.816 388.141 166.272 389.702 164.604C389.871 164.749 390.043 164.895 390.224 165.04C393.724 167.656 401.575 166.188 404.045 162.369C406.515 158.549 402.667 153.83 399.167 151.21C398.988 151.076 398.804 150.958 398.618 150.842C399.536 148.665 400.293 146.424 400.883 144.136C401.098 144.174 401.319 144.207 401.534 144.226C405.8 144.585 409.573 141.133 409.967 136.523C410.361 131.913 407.213 127.873 402.947 127.512C402.726 127.493 402.511 127.492 402.29 127.493C402.091 125.139 401.72 122.803 401.179 120.503C401.373 120.42 401.579 120.334 401.778 120.231Z",
    fill: "#BFC6D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M405.493 142.927C409.78 143.287 413.571 139.825 413.967 135.202C414.362 130.579 411.2 126.525 406.913 126.165C406.691 126.148 406.475 126.145 406.253 126.147C406.053 123.786 405.68 121.443 405.137 119.136C405.34 119.053 405.543 118.967 405.743 118.863C409.65 116.861 411.354 111.841 409.55 107.651C407.746 103.461 403.122 101.688 399.208 103.691C399.004 103.796 398.81 103.914 398.624 104.035C397.358 102.124 395.945 100.314 394.399 98.6202C394.545 98.4351 394.681 98.2486 394.811 98.0474C397.295 94.2186 396.453 88.9847 392.937 86.3568C389.42 83.7289 384.559 84.7055 382.076 88.5343C381.949 88.7311 381.837 88.9337 381.727 89.1363C379.73 88.1749 377.655 87.3836 375.524 86.7708C375.562 86.5361 375.597 86.3014 375.618 86.0624C376.008 81.4319 372.851 77.3874 368.565 77.0259C364.278 76.6645 360.487 80.126 360.091 84.7507C360.072 84.9911 360.067 85.2273 360.065 85.4648C357.862 85.7143 355.683 86.1482 353.552 86.762C353.479 86.5434 353.406 86.3248 353.308 86.1105C351.504 81.9217 346.88 80.1479 342.967 82.1519C339.053 84.156 337.355 89.1756 339.16 93.3645C339.254 93.5831 339.36 93.7915 339.469 93.997C337.661 95.409 335.965 96.9581 334.396 98.6304C334.226 98.4847 334.054 98.3389 333.871 98.1932C330.355 95.5697 325.491 96.5418 323.011 100.379C320.53 104.217 321.367 109.442 324.884 112.07C325.065 112.204 325.25 112.322 325.437 112.439C324.514 114.622 323.753 116.869 323.161 119.164C322.945 119.126 322.723 119.092 322.507 119.073C318.22 118.713 314.429 122.175 314.033 126.798C313.638 131.421 316.8 135.475 321.087 135.835C321.309 135.853 321.525 135.855 321.747 135.853C321.947 138.214 322.32 140.557 322.863 142.864C322.66 142.947 322.457 143.033 322.257 143.137C318.349 145.139 316.646 150.159 318.45 154.349C320.254 158.539 324.878 160.312 328.792 158.309C328.996 158.204 329.19 158.086 329.376 157.965C330.642 159.876 332.055 161.687 333.602 163.38C333.456 163.565 333.32 163.751 333.19 163.953C330.707 167.781 331.548 173.015 335.065 175.643C338.581 178.271 343.443 177.295 345.925 173.466C346.051 173.269 346.165 173.066 346.274 172.864C348.271 173.825 350.347 174.617 352.477 175.231C352.439 175.464 352.404 175.699 352.384 175.938C351.994 180.568 355.151 184.613 359.437 184.974C363.723 185.336 367.514 181.873 367.91 177.242C367.931 177.003 367.936 176.765 367.938 176.529C370.141 176.279 372.319 175.844 374.449 175.231C374.524 175.449 374.595 175.668 374.693 175.882C376.497 180.071 381.121 181.845 385.036 179.841C388.951 177.837 390.648 172.817 388.843 168.628C388.748 168.41 388.642 168.201 388.532 167.996C390.341 166.583 392.037 165.034 393.607 163.362C393.777 163.508 393.948 163.654 394.132 163.8C397.648 166.423 402.51 165.451 404.992 161.613C407.474 157.776 406.634 152.551 403.118 149.923C402.938 149.789 402.753 149.671 402.566 149.554C403.487 147.373 404.247 145.128 404.839 142.836C405.054 142.874 405.277 142.908 405.493 142.927ZM361.427 161.437C345.865 160.125 334.4 145.442 335.82 128.632C337.24 111.821 351.005 99.2513 366.563 100.559C382.122 101.866 393.59 116.555 392.17 133.364C390.75 150.173 376.988 162.743 361.427 161.435V161.437Z",
    fill: "#DFE3EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.652 343.397C282.717 342.749 280.988 341.601 279.639 340.069C278.29 338.538 277.37 336.677 276.971 334.675L271.262 306.418L222.423 308.158L216.412 337.595C215.571 341.718 218.941 345.854 222.821 347.372L243.255 355.36C247.051 356.847 251.138 357.44 255.2 357.092L298.382 353.395C298.998 353.339 299.575 353.073 300.016 352.64C300.458 352.208 300.736 351.636 300.804 351.022C300.951 349.748 301.835 348.319 300.631 347.92L284.652 343.397Z",
    fill: "#97A6B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.135 341.674C283.21 341.042 281.487 339.913 280.139 338.401C278.791 336.888 277.868 335.046 277.462 333.061L271.759 305.16L224.11 306.875L218.107 335.941C217.7 337.913 218.005 339.964 218.969 341.732C219.932 343.499 221.491 344.868 223.368 345.594L243.78 353.488C247.577 354.957 251.658 355.541 255.715 355.198L298.851 351.554C299.463 351.502 300.038 351.241 300.48 350.814C300.921 350.387 301.201 349.821 301.272 349.211C301.343 348.601 301.202 347.985 300.871 347.468C300.54 346.951 300.04 346.564 299.457 346.373L285.135 341.674Z",
    fill: "#164550"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.629 325.194C117.333 325.511 113 322.074 113 317.534V153.882C113 149.342 117.333 145.835 122.629 146.065L367.556 156.677C371.444 156.846 374.593 160.124 374.593 163.985V303.171C374.593 307.032 371.439 310.362 367.556 310.593L122.629 325.194Z",
    fill: "#1B5764"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.83 325.194C119.534 325.511 115.201 322.074 115.201 317.534V153.882C115.201 149.342 119.534 145.835 124.83 146.065L369.758 156.677C373.646 156.846 376.794 160.124 376.794 163.985V303.171C376.794 307.032 373.646 310.362 369.758 310.593L124.83 325.194Z",
    fill: "#35AAC5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M369.758 159.953L124.83 149.877C122.003 149.761 119.697 151.631 119.697 154.056V317.287C119.697 319.712 122 321.545 124.83 321.383L369.758 307.318C371.842 307.198 373.527 305.422 373.527 303.349V163.859C373.527 161.787 371.842 160.041 369.758 159.953Z",
    fill: "#D8DEE8"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.83 307.48C123.727 307.534 122.83 306.811 122.83 305.868V154.177C122.83 153.234 123.727 152.502 124.83 152.546L369.758 162.245C370.151 162.264 370.523 162.431 370.796 162.714C371.07 162.997 371.226 163.374 371.231 163.768V293.832C371.226 294.228 371.071 294.606 370.797 294.892C370.524 295.178 370.152 295.349 369.758 295.372L124.83 307.48Z",
    fill: "#DFE3EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M331.517 288.98V121.406L180.865 113.871V297.404C180.865 299.269 180.202 301.072 178.994 302.493C177.786 303.914 176.113 304.859 174.272 305.16L323.422 297.626C325.617 297.481 327.674 296.507 329.177 294.902C330.681 293.296 331.517 291.179 331.517 288.98Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M331.517 155.285C331.473 155.285 331.429 155.276 331.388 155.259C331.347 155.242 331.309 155.218 331.278 155.186C331.246 155.155 331.222 155.117 331.205 155.076C331.188 155.035 331.179 154.991 331.179 154.947V121.726L181.203 114.222V148.415C181.198 148.502 181.16 148.583 181.097 148.643C181.034 148.702 180.951 148.735 180.864 148.735C180.777 148.735 180.694 148.702 180.631 148.643C180.568 148.583 180.53 148.502 180.525 148.415V113.506L180.881 113.523L331.855 121.074V154.937C331.857 154.982 331.849 155.027 331.832 155.07C331.816 155.112 331.791 155.15 331.76 155.183C331.728 155.215 331.69 155.241 331.649 155.259C331.607 155.276 331.562 155.285 331.517 155.285Z",
    fill: "#D8DEE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M321.863 147.02L195.633 143.96V127.443L321.863 131.373V147.02Z",
    fill: "#D8DEE8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321.863 198.757L195.633 198.567V156.43L321.863 158.835V198.757ZM197.894 196.215L319.226 196.516V161.029L197.894 158.836V196.215Z",
    fill: "#D8DEE8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M225.025 197.153H222.388V157.943L225.025 157.987V197.153Z",
    fill: "#D8DEE8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.356 173.829L223.517 172.618V170.286L320.356 171.591V173.829Z",
    fill: "#D8DEE8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M320.356 185.97L223.517 185.277V182.945L320.356 183.734V185.97Z",
    fill: "#D8DEE8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M295.863 198.387L293.226 198.384V159.259L295.863 159.302V198.387Z",
    fill: "#D8DEE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M321.863 273.796L195.633 277.771V235.639L321.863 233.884V273.796ZM197.894 275.336L319.226 271.638V236.15L197.894 237.962V275.336Z",
    fill: "#D8DEE8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.025 275.511L222.388 275.598V236.269L225.025 236.225V275.511Z",
    fill: "#D8DEE8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M320.356 248.915L223.517 250.902V248.571L320.356 246.678V248.915Z",
    fill: "#D8DEE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M320.356 261.058L223.517 263.561V261.229L320.356 258.821V261.058Z",
    fill: "#D8DEE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M295.863 274.296L293.226 274.37V235.245L295.863 235.21V274.296Z",
    fill: "#D8DEE8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M321.863 212.165L195.633 212.718V207.326L321.863 207.055V212.165Z",
    fill: "#D8DEE8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M321.863 224.299L195.633 225.527V220.134L321.863 219.189V224.299Z",
    fill: "#D8DEE8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M321.863 287.208L195.633 291.927V286.534L321.863 282.099V287.208Z",
    fill: "#D8DEE8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M208.171 267.917L207.916 354.563C207.903 358.811 204.476 362.576 200.194 362.89L138.326 367.424C133.65 367.766 129.837 364.348 129.837 359.88V268.698C129.837 264.465 133.221 260.976 137.527 260.551C137.802 260.524 138.081 260.515 138.363 260.513L200.461 260.217C201.475 260.208 202.481 260.4 203.42 260.784C204.359 261.167 205.212 261.734 205.93 262.451C206.648 263.167 207.216 264.02 207.6 264.958C207.985 265.897 208.179 266.902 208.171 267.917Z",
    fill: "#1B5764"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.663 267.863L212.396 354.352C212.383 358.593 209.147 362.336 204.877 362.649L143.266 367.163C138.611 367.504 134.62 364.107 134.62 359.646L134.633 268.641C134.633 264.417 138.099 260.933 142.387 260.511C142.661 260.483 143.04 260.474 143.316 260.473L205.163 260.177C209.448 260.156 212.676 263.593 212.663 267.863Z",
    fill: "#35AAC5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M212.662 267.74L212.596 289.479L134.629 291.389V268.511C134.629 264.389 137.938 261.034 142.08 260.482C142.451 260.431 142.926 260.474 143.312 260.473L205.16 260.177C209.448 260.156 212.675 263.47 212.662 267.74Z",
    fill: "url(#paint0_linear_836_4652)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M208.763 284.861C208.758 285.487 208.51 286.085 208.073 286.532C207.635 286.978 207.041 287.237 206.416 287.254L142.396 288.72C140.982 288.752 139.843 287.683 139.844 286.334V271.028C139.844 269.675 140.99 268.568 142.4 268.554L206.467 267.916C206.773 267.911 207.077 267.969 207.361 268.083C207.645 268.198 207.903 268.368 208.12 268.584C208.338 268.8 208.51 269.057 208.627 269.34C208.744 269.623 208.803 269.927 208.801 270.233L208.763 284.861Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M207.278 284.562C207.275 284.957 207.118 285.336 206.842 285.617C206.565 285.899 206.189 286.062 205.794 286.072L142.105 287.48C141.215 287.5 140.494 286.828 140.494 285.972V270.733C140.494 269.88 141.217 269.18 142.108 269.172L205.836 268.512C206.03 268.509 206.222 268.545 206.402 268.617C206.581 268.69 206.744 268.797 206.882 268.934C207.019 269.07 207.128 269.232 207.202 269.411C207.276 269.59 207.314 269.782 207.313 269.975L207.278 284.562Z",
    fill: "#F4F7FA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M198.327 275.871C198.327 276.274 198.001 276.537 197.59 276.543H197.553C197.146 276.543 196.816 276.298 196.817 275.89L196.825 272.889C196.826 272.793 196.847 272.699 196.885 272.612C196.923 272.524 196.977 272.445 197.046 272.379C197.115 272.312 197.196 272.26 197.284 272.225C197.373 272.191 197.468 272.174 197.563 272.175H197.597C197.692 272.171 197.786 272.185 197.875 272.218C197.963 272.25 198.044 272.301 198.113 272.366C198.182 272.431 198.236 272.509 198.274 272.596C198.311 272.682 198.331 272.776 198.331 272.87L198.327 275.871Z",
    fill: "url(#paint1_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M204.324 275.791C204.324 276.194 203.998 276.468 203.592 276.473H203.558C203.155 276.473 202.829 276.217 202.83 275.814L202.837 272.816C202.839 272.624 202.918 272.44 203.055 272.305C203.193 272.17 203.378 272.096 203.57 272.097H203.604C203.698 272.093 203.792 272.109 203.881 272.142C203.969 272.176 204.049 272.227 204.118 272.292C204.186 272.357 204.24 272.436 204.277 272.523C204.314 272.61 204.333 272.703 204.333 272.797L204.324 275.791Z",
    fill: "url(#paint2_linear_836_4652)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M198.314 282.588C198.314 282.992 197.988 283.398 197.577 283.401H197.542C197.137 283.401 196.807 283.022 196.808 282.618L196.816 279.53C196.816 279.126 197.142 278.73 197.554 278.726H197.588C197.995 278.726 198.323 279.101 198.322 279.504L198.314 282.588Z",
    fill: "url(#paint3_linear_836_4652)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M204.305 282.506C204.305 282.908 203.979 283.034 203.573 283.351H203.54C203.136 283.351 202.81 282.938 202.811 282.535L202.82 279.305C202.82 278.903 203.146 278.354 203.553 278.349H203.586C203.989 278.349 204.315 278.878 204.314 279.28L204.305 282.506Z",
    fill: "url(#paint4_linear_836_4652)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M202.846 277.36C202.841 277.555 202.761 277.742 202.623 277.88C202.484 278.018 202.298 278.098 202.102 278.102L199.218 278.155C198.812 278.161 198.636 277.84 198.636 277.437V277.403C198.636 276.999 198.811 276.667 199.217 276.66L202.185 276.61C202.588 276.605 202.846 276.924 202.846 277.326V277.36Z",
    fill: "url(#paint5_linear_836_4652)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M202.846 271.095C202.844 271.29 202.767 271.477 202.629 271.615C202.492 271.754 202.306 271.833 202.111 271.836L199.222 271.874C198.817 271.88 198.636 271.557 198.636 271.152V271.118C198.636 270.715 198.819 270.384 199.226 270.38L202.188 270.343C202.593 270.337 202.846 270.658 202.846 271.062V271.095Z",
    fill: "url(#paint6_linear_836_4652)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M202.846 283.92C202.84 284.117 202.759 284.304 202.619 284.443C202.479 284.581 202.291 284.661 202.094 284.666L199.049 284.729C198.954 284.731 198.859 284.714 198.771 284.679C198.683 284.644 198.602 284.592 198.534 284.526C198.466 284.46 198.411 284.381 198.373 284.294C198.336 284.207 198.316 284.113 198.314 284.019V283.985C198.316 283.79 198.393 283.603 198.53 283.464C198.668 283.325 198.853 283.245 199.049 283.241L202.101 283.179C202.197 283.176 202.293 283.192 202.383 283.226C202.472 283.261 202.554 283.312 202.624 283.379C202.693 283.445 202.749 283.524 202.788 283.612C202.826 283.7 202.847 283.795 202.848 283.891L202.846 283.92Z",
    fill: "url(#paint7_linear_836_4652)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M154.624 307.093C154.624 307.993 153.863 308.75 152.931 308.784L141.558 309.194C140.607 309.227 139.837 308.518 139.837 307.609V303.459C139.837 302.549 140.608 301.788 141.558 301.758L152.936 301.403C153.87 301.373 154.627 302.08 154.626 302.981L154.624 307.093Z",
    fill: "url(#paint8_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M173.185 306.443C173.175 306.88 172.999 307.297 172.691 307.608C172.383 307.919 171.968 308.1 171.531 308.114L160.429 308.514C159.503 308.547 158.751 307.846 158.752 306.948V302.848C158.752 301.95 159.506 301.197 160.434 301.169L171.537 300.822C171.749 300.811 171.961 300.843 172.16 300.917C172.359 300.99 172.542 301.103 172.696 301.249C172.85 301.394 172.973 301.57 173.058 301.765C173.142 301.959 173.186 302.169 173.187 302.381L173.185 306.443Z",
    fill: "url(#paint9_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M190.702 305.831C190.695 306.261 190.523 306.672 190.222 306.979C189.921 307.286 189.514 307.466 189.084 307.482L178.237 307.872C178.027 307.884 177.816 307.852 177.618 307.78C177.42 307.707 177.239 307.595 177.086 307.45C176.933 307.306 176.811 307.131 176.727 306.938C176.643 306.744 176.6 306.536 176.6 306.325L176.607 302.272C176.615 301.837 176.79 301.421 177.096 301.112C177.402 300.803 177.816 300.624 178.25 300.612L189.101 300.273C189.309 300.263 189.517 300.296 189.712 300.37C189.907 300.443 190.086 300.555 190.236 300.699C190.387 300.844 190.506 301.017 190.588 301.209C190.669 301.401 190.711 301.607 190.71 301.816L190.702 305.831Z",
    fill: "url(#paint10_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M208.407 305.212C208.402 305.635 208.236 306.039 207.942 306.343C207.648 306.647 207.249 306.826 206.826 306.843L196.234 307.225C196.027 307.236 195.82 307.204 195.626 307.131C195.432 307.059 195.255 306.948 195.105 306.804C194.955 306.661 194.837 306.489 194.756 306.298C194.675 306.107 194.634 305.902 194.635 305.695L194.645 301.69C194.651 301.262 194.821 300.854 195.12 300.549C195.419 300.244 195.824 300.065 196.251 300.051L206.847 299.725C207.051 299.716 207.255 299.75 207.446 299.823C207.638 299.896 207.812 300.007 207.959 300.149C208.106 300.292 208.222 300.462 208.301 300.651C208.38 300.84 208.42 301.042 208.419 301.247L208.407 305.212Z",
    fill: "url(#paint11_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M154.612 320.294C154.612 321.193 153.851 321.956 152.92 321.997L141.552 322.504C140.603 322.546 139.833 321.845 139.833 320.937V316.79C139.833 315.881 140.605 315.114 141.555 315.076L152.926 314.624C153.86 314.587 154.616 315.286 154.615 316.186L154.612 320.294Z",
    fill: "url(#paint12_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M173.165 319.487C173.154 319.925 172.977 320.343 172.67 320.655C172.363 320.968 171.948 321.152 171.51 321.169L160.418 321.663C159.491 321.704 158.74 321.011 158.741 320.115V316.018C158.741 315.12 159.494 314.363 160.421 314.326L171.52 313.884C171.731 313.871 171.943 313.901 172.142 313.973C172.341 314.044 172.523 314.156 172.678 314.3C172.832 314.445 172.955 314.62 173.039 314.814C173.124 315.008 173.167 315.217 173.168 315.428L173.165 319.487Z",
    fill: "url(#paint13_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M190.668 318.726C190.66 319.156 190.489 319.568 190.189 319.876C189.889 320.185 189.482 320.368 189.052 320.387L178.21 320.87C178.001 320.884 177.79 320.855 177.592 320.784C177.394 320.714 177.213 320.603 177.059 320.459C176.906 320.316 176.784 320.142 176.7 319.949C176.617 319.756 176.574 319.548 176.574 319.338L176.58 315.289C176.589 314.853 176.764 314.438 177.07 314.127C177.375 313.816 177.788 313.634 178.224 313.618L189.068 313.183C189.275 313.171 189.483 313.201 189.678 313.273C189.873 313.344 190.051 313.454 190.202 313.597C190.352 313.739 190.472 313.911 190.554 314.102C190.636 314.292 190.678 314.498 190.678 314.705L190.668 318.726Z",
    fill: "url(#paint14_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M208.37 317.956C208.364 318.379 208.198 318.784 207.904 319.089C207.611 319.394 207.212 319.576 206.79 319.598L196.203 320.069C195.997 320.081 195.79 320.051 195.596 319.981C195.402 319.91 195.225 319.8 195.075 319.658C194.925 319.516 194.806 319.345 194.725 319.155C194.644 318.965 194.603 318.76 194.605 318.554L194.615 314.552C194.622 314.124 194.792 313.715 195.09 313.408C195.388 313.101 195.792 312.92 196.22 312.901L206.81 312.48C207.014 312.47 207.218 312.501 207.409 312.573C207.601 312.644 207.775 312.754 207.922 312.895C208.07 313.037 208.186 313.207 208.265 313.395C208.344 313.583 208.384 313.785 208.382 313.99L208.37 317.956Z",
    fill: "url(#paint15_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M154.602 333.175C154.602 334.074 153.84 334.842 152.909 334.892L141.546 335.492C140.598 335.542 139.828 334.847 139.828 333.94V329.803C139.828 328.896 140.599 328.123 141.548 328.077L152.914 327.534C153.848 327.489 154.604 328.181 154.603 329.08L154.602 333.175Z",
    fill: "url(#paint16_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M173.144 332.214C173.144 333.102 172.403 333.861 171.492 333.909L160.399 334.495C159.472 334.544 158.722 333.858 158.723 332.961V328.868C158.723 327.972 159.477 327.208 160.402 327.164L171.495 326.631C171.705 326.616 171.916 326.644 172.115 326.713C172.314 326.783 172.497 326.893 172.651 327.037C172.806 327.18 172.929 327.353 173.014 327.547C173.098 327.74 173.142 327.948 173.143 328.159L173.144 332.214Z",
    fill: "url(#paint17_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M190.64 331.307C190.632 331.739 190.461 332.151 190.161 332.461C189.862 332.771 189.456 332.957 189.025 332.981L178.188 333.554C177.979 333.569 177.77 333.541 177.573 333.471C177.376 333.402 177.195 333.293 177.042 333.15C176.889 333.008 176.767 332.836 176.684 332.644C176.6 332.453 176.557 332.246 176.557 332.037L176.563 327.991C176.573 327.555 176.748 327.139 177.053 326.826C177.357 326.514 177.769 326.329 178.205 326.308L189.045 325.787C189.251 325.773 189.459 325.802 189.654 325.871C189.849 325.941 190.028 326.05 190.179 326.192C190.33 326.334 190.45 326.505 190.532 326.696C190.614 326.886 190.655 327.091 190.654 327.299L190.64 331.307Z",
    fill: "url(#paint18_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M208.334 330.391C208.328 330.814 208.161 331.22 207.868 331.526C207.576 331.833 207.178 332.018 206.755 332.044L196.171 332.604C195.966 332.618 195.76 332.59 195.566 332.521C195.372 332.452 195.195 332.343 195.045 332.202C194.895 332.061 194.776 331.891 194.695 331.702C194.614 331.513 194.573 331.309 194.575 331.103L194.585 327.105C194.592 326.676 194.762 326.266 195.06 325.958C195.358 325.649 195.761 325.465 196.19 325.442L206.775 324.933C206.978 324.921 207.181 324.95 207.373 325.02C207.564 325.089 207.739 325.198 207.886 325.338C208.034 325.478 208.151 325.648 208.23 325.835C208.308 326.023 208.348 326.225 208.345 326.429L208.334 330.391Z",
    fill: "url(#paint19_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M154.59 345.738C154.59 346.635 153.828 347.409 152.9 347.466L141.546 348.158C140.598 348.216 139.828 347.529 139.828 346.623V342.484C139.828 341.577 140.598 340.799 141.546 340.744L152.906 340.104C153.84 340.052 154.595 340.737 154.595 341.636L154.59 345.738Z",
    fill: "url(#paint20_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M173.124 344.626C173.124 345.514 172.384 346.277 171.472 346.333L160.387 347.009C159.462 347.065 158.711 346.386 158.712 345.486V341.397C158.712 340.501 159.465 339.733 160.39 339.681L171.483 339.057C172.395 339.006 173.132 339.683 173.131 340.571L173.124 344.626Z",
    fill: "url(#paint21_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M190.613 343.578C190.603 344.01 190.432 344.423 190.133 344.735C189.834 345.047 189.429 345.235 188.998 345.263L178.166 345.925C177.958 345.942 177.749 345.917 177.552 345.849C177.354 345.781 177.173 345.674 177.02 345.532C176.866 345.391 176.744 345.219 176.66 345.028C176.577 344.837 176.534 344.63 176.535 344.422L176.542 340.38C176.553 339.943 176.727 339.526 177.032 339.212C177.336 338.898 177.747 338.71 178.183 338.685L189.017 338.076C189.223 338.06 189.43 338.086 189.626 338.154C189.821 338.222 190 338.33 190.151 338.471C190.302 338.612 190.422 338.783 190.504 338.972C190.586 339.162 190.627 339.367 190.626 339.574L190.613 343.578Z",
    fill: "url(#paint22_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M154.578 359.206C154.578 360.103 153.816 360.882 152.887 360.946L141.537 361.736C140.589 361.803 139.82 361.123 139.82 360.214V356.081C139.82 355.176 140.59 354.391 141.538 354.33L152.893 353.593C153.826 353.532 154.581 354.209 154.581 355.107L154.578 359.206Z",
    fill: "url(#paint23_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M173.102 357.934C173.102 358.821 172.363 359.589 171.452 359.654L160.372 360.426C159.448 360.49 158.697 359.818 158.698 358.923V354.838C158.698 353.944 159.451 353.17 160.376 353.109L171.459 352.389C172.37 352.33 173.107 353.001 173.105 353.888L173.102 357.934Z",
    fill: "url(#paint24_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M190.583 356.734C190.574 357.167 190.403 357.581 190.105 357.896C189.806 358.21 189.401 358.401 188.968 358.432L178.142 359.187C177.238 359.25 176.511 358.585 176.511 357.7L176.518 353.662C176.518 352.778 177.255 352.014 178.158 351.955L188.988 351.251C189.193 351.233 189.4 351.258 189.595 351.324C189.79 351.39 189.969 351.497 190.12 351.636C190.271 351.776 190.392 351.946 190.474 352.135C190.556 352.324 190.597 352.528 190.595 352.734L190.583 356.734Z",
    fill: "url(#paint25_linear_836_4652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M206.688 337.081L196.107 337.677C195.224 337.726 194.558 338.713 194.557 339.589V341.839L194.551 343.717L194.532 352.2L194.525 354.694V356.326C194.525 357.196 195.178 358.002 196.065 357.941L206.64 357.203C207.51 357.142 208.272 356.249 208.272 355.383V353.768L208.279 351.296L208.303 342.892V341.03L208.31 338.8C208.312 337.931 207.558 337.032 206.688 337.081Z",
    fill: "url(#paint26_linear_836_4652)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M155.26 307.074C155.26 307.973 154.499 308.73 153.569 308.764L142.204 309.173C141.255 309.208 140.486 308.499 140.486 307.591V303.441C140.486 302.533 141.257 301.771 142.206 301.742L153.573 301.386C154.507 301.357 155.263 302.064 155.263 302.963L155.26 307.074Z",
    fill: "url(#paint27_linear_836_4652)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M173.184 306.443C173.175 306.88 172.998 307.297 172.69 307.608C172.383 307.919 171.967 308.1 171.53 308.114L160.429 308.514C159.502 308.547 158.751 307.846 158.752 306.948V302.848C158.752 301.95 159.506 301.197 160.433 301.169L171.537 300.822C171.749 300.811 171.961 300.843 172.16 300.917C172.359 300.99 172.541 301.103 172.695 301.249C172.85 301.394 172.973 301.57 173.057 301.765C173.142 301.959 173.186 302.169 173.187 302.381L173.184 306.443Z",
    fill: "url(#paint28_linear_836_4652)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M191.304 305.81C191.297 306.24 191.125 306.65 190.825 306.957C190.524 307.264 190.117 307.444 189.688 307.46L178.851 307.85C178.641 307.861 178.43 307.829 178.233 307.756C178.036 307.683 177.856 307.571 177.703 307.426C177.55 307.282 177.429 307.108 177.346 306.914C177.263 306.721 177.22 306.513 177.219 306.303L177.227 302.251C177.235 301.816 177.41 301.401 177.716 301.093C178.021 300.784 178.435 300.605 178.869 300.592L189.709 300.254C189.918 300.245 190.126 300.277 190.321 300.351C190.516 300.424 190.694 300.536 190.845 300.68C190.995 300.824 191.115 300.998 191.196 301.19C191.278 301.381 191.32 301.588 191.319 301.796L191.304 305.81Z",
    fill: "url(#paint29_linear_836_4652)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M209 305.192C208.996 305.614 208.829 306.019 208.535 306.322C208.241 306.626 207.842 306.805 207.42 306.823L196.836 307.203C196.63 307.213 196.423 307.181 196.229 307.109C196.035 307.036 195.858 306.925 195.709 306.782C195.559 306.639 195.441 306.466 195.36 306.276C195.279 306.085 195.238 305.88 195.24 305.673L195.25 301.67C195.255 301.243 195.425 300.835 195.724 300.53C196.022 300.224 196.427 300.046 196.854 300.031L207.441 299.705C207.645 299.697 207.849 299.73 208.04 299.803C208.231 299.876 208.405 299.987 208.552 300.13C208.699 300.272 208.815 300.443 208.894 300.632C208.973 300.82 209.013 301.023 209.011 301.227L209 305.192Z",
    fill: "url(#paint30_linear_836_4652)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M155.248 320.266C155.248 321.165 154.487 321.927 153.557 321.969L142.198 322.476C141.249 322.518 140.479 321.816 140.479 320.908V316.763C140.479 315.855 141.249 315.088 142.199 315.051L153.56 314.599C154.494 314.562 155.249 315.261 155.249 316.16L155.248 320.266Z",
    fill: "url(#paint31_linear_836_4652)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.164 319.487C173.153 319.925 172.976 320.343 172.669 320.655C172.362 320.968 171.947 321.152 171.509 321.169L160.417 321.663C159.49 321.704 158.739 321.011 158.74 320.114V316.018C158.74 315.119 159.493 314.363 160.42 314.326L171.519 313.884C171.73 313.871 171.942 313.901 172.141 313.973C172.34 314.044 172.522 314.156 172.677 314.3C172.831 314.445 172.954 314.62 173.038 314.814C173.123 315.008 173.166 315.217 173.167 315.428L173.164 319.487Z",
    fill: "url(#paint32_linear_836_4652)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M191.275 318.699C191.268 319.129 191.096 319.54 190.796 319.849C190.496 320.158 190.089 320.34 189.659 320.36L178.827 320.843C178.617 320.856 178.408 320.826 178.211 320.755C178.013 320.684 177.833 320.574 177.68 320.43C177.527 320.287 177.405 320.113 177.322 319.921C177.239 319.729 177.195 319.522 177.195 319.312L177.203 315.264C177.211 314.829 177.386 314.413 177.691 314.102C177.996 313.792 178.409 313.609 178.844 313.593L189.68 313.158C189.887 313.146 190.094 313.177 190.289 313.248C190.484 313.319 190.662 313.429 190.813 313.572C190.963 313.715 191.083 313.886 191.165 314.077C191.247 314.268 191.289 314.473 191.289 314.68L191.275 318.699Z",
    fill: "url(#paint33_linear_836_4652)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M208.962 317.93C208.956 318.352 208.79 318.757 208.497 319.062C208.204 319.367 207.806 319.549 207.384 319.571L196.805 320.043C196.599 320.055 196.392 320.025 196.198 319.954C196.005 319.883 195.827 319.773 195.678 319.631C195.528 319.489 195.409 319.318 195.328 319.128C195.248 318.939 195.207 318.734 195.208 318.528L195.218 314.528C195.225 314.1 195.394 313.691 195.693 313.384C195.991 313.078 196.395 312.896 196.822 312.877L207.404 312.456C207.607 312.446 207.811 312.477 208.002 312.549C208.193 312.62 208.368 312.73 208.515 312.872C208.662 313.013 208.779 313.183 208.858 313.371C208.937 313.559 208.976 313.762 208.974 313.966L208.962 317.93Z",
    fill: "url(#paint34_linear_836_4652)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M155.236 333.142C155.236 334.04 154.475 334.808 153.546 334.858L142.198 335.458C141.249 335.508 140.48 334.813 140.48 333.906V329.766C140.48 328.859 141.25 328.086 142.199 328.04L153.555 327.497C154.488 327.452 155.244 328.144 155.243 329.042L155.236 333.142Z",
    fill: "url(#paint35_linear_836_4652)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.143 332.214C173.143 333.102 172.403 333.861 171.491 333.909L160.399 334.495C159.472 334.544 158.722 333.858 158.723 332.961V328.868C158.723 327.972 159.476 327.208 160.402 327.164L171.495 326.631C171.705 326.616 171.916 326.644 172.115 326.713C172.314 326.783 172.496 326.893 172.651 327.037C172.805 327.18 172.929 327.353 173.013 327.547C173.098 327.74 173.142 327.948 173.142 328.159L173.143 332.214Z",
    fill: "url(#paint36_linear_836_4652)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M191.245 331.276C191.236 331.707 191.065 332.119 190.766 332.429C190.467 332.739 190.062 332.925 189.631 332.949L178.803 333.521C178.594 333.536 178.385 333.508 178.188 333.439C177.991 333.369 177.81 333.26 177.657 333.118C177.504 332.976 177.382 332.804 177.299 332.612C177.215 332.421 177.172 332.214 177.171 332.005L177.178 327.961C177.188 327.525 177.363 327.109 177.667 326.797C177.972 326.485 178.383 326.299 178.819 326.279L189.65 325.758C189.856 325.744 190.064 325.773 190.259 325.842C190.454 325.912 190.632 326.021 190.783 326.163C190.934 326.305 191.054 326.476 191.136 326.667C191.218 326.857 191.259 327.062 191.258 327.269L191.245 331.276Z",
    fill: "url(#paint37_linear_836_4652)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M208.926 330.359C208.919 330.783 208.753 331.188 208.461 331.494C208.168 331.801 207.771 331.986 207.348 332.012L196.773 332.572C196.568 332.586 196.362 332.558 196.168 332.489C195.974 332.42 195.797 332.312 195.647 332.171C195.497 332.03 195.378 331.86 195.297 331.671C195.216 331.482 195.176 331.278 195.177 331.072L195.187 327.076C195.194 326.647 195.364 326.238 195.661 325.929C195.959 325.621 196.362 325.437 196.79 325.414L207.367 324.905C207.57 324.892 207.774 324.922 207.965 324.991C208.156 325.061 208.331 325.169 208.478 325.31C208.625 325.45 208.742 325.619 208.821 325.807C208.9 325.994 208.939 326.196 208.937 326.399L208.926 330.359Z",
    fill: "url(#paint38_linear_836_4652)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M155.226 345.7C155.226 346.597 154.464 347.37 153.535 347.427L142.188 348.119C141.241 348.177 140.472 347.49 140.472 346.584V342.451C140.472 341.545 141.242 340.767 142.19 340.711L153.541 340.073C154.474 340.021 155.229 340.706 155.228 341.604L155.226 345.7Z",
    fill: "url(#paint39_linear_836_4652)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M173.123 344.626C173.123 345.514 172.383 346.277 171.471 346.332L160.386 347.009C159.461 347.065 158.71 346.386 158.711 345.486V341.397C158.711 340.501 159.464 339.733 160.389 339.681L171.482 339.057C172.394 339.006 173.131 339.683 173.13 340.571L173.123 344.626Z",
    fill: "url(#paint40_linear_836_4652)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M191.219 343.542C191.209 343.974 191.038 344.386 190.74 344.698C190.441 345.01 190.036 345.198 189.605 345.226L178.782 345.887C178.574 345.904 178.365 345.879 178.168 345.811C177.97 345.744 177.789 345.636 177.636 345.495C177.482 345.354 177.36 345.182 177.277 344.991C177.193 344.8 177.15 344.593 177.151 344.385L177.158 340.345C177.169 339.908 177.344 339.491 177.648 339.177C177.952 338.863 178.362 338.675 178.798 338.65L189.624 338.041C189.83 338.025 190.037 338.052 190.232 338.12C190.427 338.188 190.605 338.296 190.756 338.437C190.908 338.578 191.028 338.748 191.109 338.938C191.191 339.128 191.233 339.332 191.231 339.539L191.219 343.542Z",
    fill: "url(#paint41_linear_836_4652)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M155.212 359.166C155.212 360.064 154.457 360.842 153.525 360.906L142.183 361.697C141.236 361.763 140.467 361.083 140.468 360.174V356.042C140.468 355.137 141.237 354.353 142.184 354.291L153.53 353.555C154.462 353.494 155.217 354.171 155.216 355.069L155.212 359.166Z",
    fill: "url(#paint42_linear_836_4652)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M173.102 357.934C173.102 358.821 172.362 359.589 171.451 359.654L160.371 360.426C159.447 360.49 158.697 359.818 158.698 358.923V354.838C158.698 353.944 159.45 353.17 160.376 353.109L171.459 352.389C172.369 352.33 173.106 353.001 173.104 353.888L173.102 357.934Z",
    fill: "url(#paint43_linear_836_4652)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M191.189 356.692C191.179 357.125 191.009 357.539 190.711 357.853C190.412 358.167 190.008 358.358 189.576 358.39L178.758 359.144C177.855 359.207 177.127 358.542 177.127 357.658L177.133 353.622C177.145 353.184 177.319 352.767 177.623 352.451C177.926 352.135 178.337 351.944 178.773 351.915L189.593 351.211C189.798 351.193 190.005 351.218 190.2 351.284C190.395 351.351 190.573 351.457 190.725 351.597C190.876 351.736 190.996 351.906 191.078 352.095C191.16 352.284 191.201 352.488 191.199 352.693L191.189 356.692Z",
    fill: "url(#paint44_linear_836_4652)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M207.301 337.047L196.728 337.642C195.845 337.691 195.159 338.68 195.157 339.554V341.803V343.681L195.136 352.158V354.653V356.284C195.136 357.154 195.816 357.958 196.697 357.897L207.263 357.16C208.133 357.1 208.869 356.207 208.872 355.343V353.728L208.879 351.257L208.904 342.856V340.995L208.911 338.767C208.903 337.898 208.17 336.998 207.301 337.047Z",
    fill: "url(#paint45_linear_836_4652)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M190.049 221.665C190.049 236.422 178.51 248.03 163.763 247.578C148.415 247.106 135.507 233.851 135.507 217.988C135.507 202.126 148.415 190.612 163.763 192.214C178.512 193.745 190.049 206.913 190.049 221.665Z",
    fill: "url(#paint46_linear_836_4652)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M194.037 220.398C194.037 235.155 182.498 246.763 167.75 246.311C152.402 245.839 139.494 232.584 139.494 216.721C139.494 200.859 152.402 189.345 167.75 190.947C182.498 192.473 194.037 205.637 194.037 220.398Z",
    fill: "url(#paint47_linear_836_4652)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M192.876 220.316C192.876 234.422 181.836 245.5 167.748 245.044C153.116 244.57 140.828 231.92 140.828 216.81C140.828 201.7 153.117 190.703 167.75 192.202C181.838 193.645 192.876 206.208 192.876 220.316Z",
    fill: "url(#paint48_linear_836_4652)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M192.05 220.259C192.05 233.901 181.367 244.6 167.75 244.143C153.623 243.669 141.777 231.451 141.777 216.871C141.777 202.29 153.623 191.669 167.755 193.102C181.367 194.478 192.05 206.618 192.05 220.259Z",
    fill: "url(#paint49_linear_836_4652)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M167.611 197.74C167.968 197.784 168.297 197.955 168.537 198.223C168.777 198.491 168.912 198.837 168.916 199.197V201.709C170.38 201.873 171.833 202.125 173.266 202.464C174.337 202.716 175.401 203.015 176.458 203.363C176.769 203.467 177.037 203.671 177.218 203.944C177.4 204.217 177.484 204.543 177.459 204.87L177.151 208.023C177.137 208.215 177.076 208.4 176.974 208.563C176.872 208.726 176.732 208.861 176.566 208.957C176.4 209.054 176.213 209.108 176.021 209.116C175.829 209.124 175.639 209.085 175.465 209.002C174.769 208.692 174.053 208.426 173.323 208.205C172.007 207.811 170.653 207.557 169.284 207.449L168.913 207.419V214.612C172.693 215.67 175.476 217.093 177.263 218.881C179.049 220.669 179.941 222.891 179.938 225.547C179.938 228.428 178.952 230.738 176.98 232.475C174.994 234.225 172.211 235.209 168.606 235.421V238.194C168.609 238.365 168.577 238.536 168.512 238.694C168.447 238.853 168.35 238.997 168.227 239.117C168.104 239.237 167.958 239.331 167.798 239.392C167.637 239.454 167.466 239.482 167.295 239.475H167.271C166.915 239.455 166.581 239.3 166.336 239.042C166.091 238.783 165.954 238.441 165.954 238.085V235.351L165.37 235.324C163.745 235.254 162.126 235.082 160.523 234.807C159.393 234.611 158.274 234.354 157.172 234.037C156.852 233.947 156.572 233.75 156.381 233.478C156.189 233.206 156.098 232.876 156.121 232.544L156.485 228.496C156.563 227.621 157.442 227.112 158.274 227.439C159.236 227.82 160.22 228.143 161.221 228.407C162.763 228.814 164.34 229.077 165.931 229.193L165.954 221.192C162.326 220.295 159.609 218.965 157.825 217.203C156.04 215.441 155.132 213.17 155.132 210.416C155.132 207.565 156.105 205.367 158.051 203.822C159.986 202.287 162.729 201.521 166.281 201.524V198.952C166.276 198.782 166.308 198.612 166.375 198.454C166.441 198.297 166.541 198.156 166.668 198.041C166.794 197.926 166.944 197.839 167.107 197.787C167.269 197.735 167.442 197.719 167.611 197.74ZM166.295 207.342C165.174 207.424 164.3 207.732 163.673 208.266C163.046 208.8 162.733 209.52 162.733 210.425C162.722 210.823 162.794 211.219 162.944 211.588C163.094 211.957 163.318 212.292 163.603 212.57C164.183 213.143 165.08 213.601 166.295 213.944V207.342ZM168.625 221.83V229.167C169.844 229.167 170.78 228.877 171.432 228.297C172.083 227.717 172.41 226.893 172.41 225.826C172.41 224.856 172.108 224.051 171.502 223.412C170.897 222.772 169.938 222.245 168.625 221.83Z",
    fill: "url(#paint50_linear_836_4652)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M163.353 223.6C164.173 215.492 171.626 212.058 170.654 204.6C170.055 200.003 166.57 196.128 162.682 193.104C150.894 194.34 141.777 204.102 141.777 216.871C141.777 231.451 153.623 243.669 167.75 244.143C169.091 244.188 170.434 244.122 171.764 243.948C166.154 238.364 162.643 230.567 163.353 223.6Z",
    fill: "url(#paint51_linear_836_4652)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M194.627 150.399C194.627 167.826 180.999 181.536 163.583 181.001C145.46 180.444 130.211 164.789 130.211 146.055C130.211 127.322 145.456 113.723 163.583 115.605C180.999 117.424 194.627 132.97 194.627 150.399Z",
    fill: "url(#paint52_linear_836_4652)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M199.334 148.896C199.334 166.324 185.706 180.033 168.289 179.498C150.162 178.941 134.917 163.286 134.917 144.553C134.917 125.821 150.162 112.22 168.289 114.103C185.706 115.921 199.334 131.468 199.334 148.896Z",
    fill: "url(#paint53_linear_836_4652)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M197.967 148.804C197.967 165.463 184.928 178.547 168.29 178.009C151.005 177.449 136.493 162.509 136.493 144.659C136.493 126.809 151.007 113.827 168.29 115.597C184.928 117.301 197.967 132.144 197.967 148.804Z",
    fill: "url(#paint54_linear_836_4652)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M196.987 148.737C196.987 164.848 184.372 177.485 168.29 176.944C151.605 176.384 137.614 161.955 137.614 144.735C137.614 127.515 151.605 114.972 168.29 116.661C184.371 118.29 196.987 132.627 196.987 148.737Z",
    fill: "url(#paint55_linear_836_4652)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M168.124 122.142C168.547 122.192 168.938 122.394 169.223 122.71C169.508 123.027 169.668 123.436 169.673 123.862V126.829C171.403 127.023 173.12 127.321 174.814 127.721C176.08 128.018 177.337 128.372 178.584 128.782C178.951 128.905 179.266 129.147 179.48 129.47C179.694 129.792 179.794 130.177 179.765 130.563L179.401 134.282C179.384 134.508 179.313 134.727 179.193 134.919C179.073 135.111 178.907 135.272 178.711 135.386C178.515 135.5 178.294 135.564 178.068 135.573C177.841 135.583 177.616 135.537 177.411 135.439C176.588 135.072 175.743 134.757 174.881 134.496C173.327 134.031 171.728 133.732 170.11 133.605L169.675 133.568V142.064C174.134 143.313 177.418 144.993 179.537 147.107C181.655 149.221 182.691 151.831 182.691 154.978C182.691 158.381 181.526 161.108 179.197 163.161C176.852 165.227 173.565 166.39 169.314 166.641V169.915C169.318 170.117 169.28 170.319 169.202 170.506C169.125 170.694 169.011 170.863 168.866 171.005C168.72 171.147 168.548 171.257 168.359 171.33C168.169 171.402 167.967 171.436 167.764 171.427H167.737C167.317 171.404 166.922 171.222 166.633 170.916C166.344 170.611 166.182 170.207 166.182 169.786V166.556L165.492 166.525C163.572 166.443 161.66 166.24 159.767 165.915C158.432 165.683 157.111 165.38 155.809 165.004C155.431 164.898 155.101 164.665 154.875 164.344C154.649 164.023 154.541 163.634 154.569 163.243L154.997 158.457C155.089 157.424 156.128 156.826 157.111 157.21C158.247 157.66 159.41 158.041 160.591 158.352C162.413 158.834 164.275 159.145 166.154 159.282L166.182 149.832C161.897 148.772 158.696 147.202 156.58 145.121C154.465 143.04 153.404 140.369 153.399 137.106C153.399 133.741 154.549 131.146 156.847 129.319C159.131 127.505 162.378 126.601 166.566 126.601V123.573C166.56 123.372 166.598 123.173 166.676 122.988C166.754 122.803 166.871 122.638 167.019 122.502C167.167 122.366 167.342 122.264 167.532 122.202C167.723 122.14 167.925 122.119 168.124 122.142ZM166.57 133.481C165.247 133.577 164.215 133.94 163.474 134.569C162.733 135.198 162.363 136.048 162.364 137.119C162.364 138.134 162.706 138.979 163.392 139.653C164.077 140.327 165.136 140.868 166.57 141.276V133.481ZM169.317 150.591V159.257C170.757 159.257 171.862 158.914 172.631 158.227C173.4 157.54 173.785 156.568 173.785 155.31C173.785 154.164 173.428 153.213 172.713 152.458C171.998 151.702 170.866 151.08 169.317 150.591Z",
    fill: "url(#paint56_linear_836_4652)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M163.096 152.683C164.066 143.106 172.867 139.052 171.719 130.243C171.011 124.814 166.895 120.238 162.305 116.666C148.385 118.126 137.618 129.656 137.618 144.735C137.618 161.955 151.609 176.382 168.294 176.944C169.877 176.997 171.462 176.92 173.033 176.714C166.404 170.12 162.263 160.911 163.096 152.683Z",
    fill: "url(#paint57_linear_836_4652)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_836_4652",
    x: 0,
    y: 0,
    width: 502,
    height: 484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.666667 0 0 0 0 0.772549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_836_4652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_836_4652",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_836_4652",
    x1: 61032.4,
    y1: 74022.6,
    x2: 117023,
    y2: 74022.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_836_4652",
    x1: 197.766,
    y1: 270.105,
    x2: 196.711,
    y2: 294.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_836_4652",
    x1: 2331.24,
    y1: 10383.6,
    x2: 2209.1,
    y2: 11340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_836_4652",
    x1: 2257.01,
    y1: 11358.7,
    x2: 2109.41,
    y2: 12447.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_836_4652",
    x1: 2331.39,
    y1: 12107.1,
    x2: 2149.99,
    y2: 13349.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_836_4652",
    x1: 5208.86,
    y1: 25724.7,
    x2: 4879.42,
    y2: 25719.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_836_4652",
    x1: 5167.18,
    y1: 25481.7,
    x2: 4840.47,
    y2: 25476.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_836_4652",
    x1: 5225.6,
    y1: 27997.5,
    x2: 4869.61,
    y2: 27992.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_836_4652",
    x1: 212.961,
    y1: 268.71,
    x2: 91.8538,
    y2: 336.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_836_4652",
    x1: 22249.7,
    y1: 18551.9,
    x2: 12391.2,
    y2: 28839.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_836_4652",
    x1: 22141.6,
    y1: 18869.1,
    x2: 12597.7,
    y2: 28721.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_836_4652",
    x1: 22110,
    y1: 19130.3,
    x2: 12887.6,
    y2: 28554.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_836_4652",
    x1: 23140.2,
    y1: 19151.2,
    x2: 12783.2,
    y2: 29954.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_836_4652",
    x1: 23011.8,
    y1: 19480.3,
    x2: 13002.8,
    y2: 29800.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_836_4652",
    x1: 22865.1,
    y1: 19795,
    x2: 13173.8,
    y2: 29678.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_836_4652",
    x1: 22794.6,
    y1: 20047.8,
    x2: 13429.6,
    y2: 29499.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_836_4652",
    x1: 23951.8,
    y1: 20055.6,
    x2: 13453.1,
    y2: 30892.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_836_4652",
    x1: 23779,
    y1: 20395.2,
    x2: 13623.8,
    y2: 30745.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_836_4652",
    x1: 23592.4,
    y1: 20688.7,
    x2: 13766.6,
    y2: 30600.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_836_4652",
    x1: 23482.8,
    y1: 20940.9,
    x2: 13984.8,
    y2: 30418.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_836_4652",
    x1: 24764.9,
    y1: 20993.9,
    x2: 14101.9,
    y2: 31861.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_836_4652",
    x1: 24556.9,
    y1: 21302.9,
    x2: 14255.8,
    y2: 31685.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_836_4652",
    x1: 24322.9,
    y1: 21581.6,
    x2: 14359.9,
    y2: 31519.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_836_4652",
    x1: 25586.5,
    y1: 21999.7,
    x2: 14765.8,
    y2: 32899.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_836_4652",
    x1: 25324.3,
    y1: 22288.3,
    x2: 14876.3,
    y2: 32696.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_836_4652",
    x1: 25058.7,
    y1: 22560.3,
    x2: 14953.2,
    y2: 32525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_836_4652",
    x1: 24546,
    y1: 59071.5,
    x2: 7785.84,
    y2: 65231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_836_4652",
    x1: 13520.4,
    y1: 20242,
    x2: 13444.7,
    y2: 23515.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_836_4652",
    x1: 15629.9,
    y1: 19966.2,
    x2: 15555.2,
    y2: 23158.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_836_4652",
    x1: 17660.3,
    y1: 19686.5,
    x2: 17586.8,
    y2: 22798.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_836_4652",
    x1: 19532.5,
    y1: 19400.2,
    x2: 19460.1,
    y2: 22431.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_836_4652",
    x1: 13512.9,
    y1: 21443.6,
    x2: 13434.6,
    y2: 24791.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_836_4652",
    x1: 15620,
    y1: 21137.4,
    x2: 15542.7,
    y2: 24402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_836_4652",
    x1: 17649.4,
    y1: 20841.3,
    x2: 17573.2,
    y2: 24024.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_836_4652",
    x1: 19521,
    y1: 20528.7,
    x2: 19446,
    y2: 23629.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_836_4652",
    x1: 13505.4,
    y1: 22628.9,
    x2: 13424.5,
    y2: 26050,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_836_4652",
    x1: 15611.2,
    y1: 22301.2,
    x2: 15531.3,
    y2: 25636.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_836_4652",
    x1: 17638.5,
    y1: 21964.9,
    x2: 17559.8,
    y2: 25214.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_836_4652",
    x1: 19508,
    y1: 21636.2,
    x2: 19430.6,
    y2: 24802.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_836_4652",
    x1: 13498.9,
    y1: 23811.5,
    x2: 13415.3,
    y2: 27305.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_836_4652",
    x1: 15607.1,
    y1: 23464.7,
    x2: 15524.7,
    y2: 26871.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_836_4652",
    x1: 17627.6,
    y1: 23096.4,
    x2: 17546.4,
    y2: 26414.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_836_4652",
    x1: 13491.4,
    y1: 25117.2,
    x2: 13404.8,
    y2: 28692.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_836_4652",
    x1: 15592.4,
    y1: 24712.4,
    x2: 15507.2,
    y2: 28194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_836_4652",
    x1: 17615.2,
    y1: 24319.9,
    x2: 17531.2,
    y2: 27710.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_836_4652",
    x1: 19593.8,
    y1: 59387.8,
    x2: 18103.4,
    y2: 81833.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_836_4652",
    x1: 153.433,
    y1: 222.82,
    x2: 121.624,
    y2: 233.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_836_4652",
    x1: 179.164,
    y1: 191.158,
    x2: 150.767,
    y2: 253.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_836_4652",
    x1: 59574.4,
    y1: 116424,
    x2: 56859.5,
    y2: 101856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_836_4652",
    x1: 52177.3,
    y1: 89659.3,
    x2: 62926.3,
    y2: 112071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_836_4652",
    x1: 25626.1,
    y1: 69203.2,
    x2: 32164.1,
    y2: 83764.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_836_4652",
    x1: 29348.9,
    y1: 90884.4,
    x2: 42741.5,
    y2: 107584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_836_4652",
    x1: 60322.6,
    y1: 80317.4,
    x2: 37997.7,
    y2: 87354.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_836_4652",
    x1: 78327.8,
    y1: 57764.4,
    x2: 57863.8,
    y2: 102107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_836_4652",
    x1: 71271,
    y1: 100096,
    x2: 67483.9,
    y2: 79774.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_836_4652",
    x1: 61350.3,
    y1: 64876.4,
    x2: 76344.1,
    y2: 96136.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_836_4652",
    x1: 30066,
    y1: 47408,
    x2: 39185.4,
    y2: 67715.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_836_4652",
    x1: 34095.1,
    y1: 66738.2,
    x2: 52775.7,
    y2: 90030,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg55);
export default __webpack_public_path__ + "static/media/img_55.28f972a1a1b7e5ecbf259b1902743711.svg";
export { ForwardRef as ReactComponent };